import chalk from 'chalk';

const logLevels = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
};

const colors = {
  debug: chalk.blue,
  info: chalk.grey,
  warn: chalk.yellow,
  error: chalk.red,
};

const formatMessage = (args) => {
  return args
    .map((arg) => {
      if (arg instanceof Error) {
        return arg.stack || arg.message;
      }
      if (typeof arg === 'object') {
        return JSON.stringify(arg, null, 2);
      }
      return arg;
    })
    .join(' ');
};

// Initialize variables for logging
let logging = null;
let glog = null;

// Timer storage
const timers = new Map();

const time = (label = 'default') => {
  timers.set(label, performance.now());
  debug(`Timer '${label}' started`);
};

const timeEnd = (label = 'default') => {
  const start = timers.get(label);
  if (!start) {
    warn(`Timer '${label}' does not exist`);
    return;
  }

  const duration = performance.now() - start;
  timers.delete(label);
  debug(`Timer '${label}': ${duration.toFixed(3)}ms`);
};

const log = (level, ...args) => {
  const runtimeConfig = useRuntimeConfig();

  const message = formatMessage(args);
  const logMessage = {
    level,
    message,
    timestamp: new Date().toISOString(),
  };

  if (runtimeConfig.ENV_TYPE === 'production' && glog) {
    if (
      (runtimeConfig.ENV === 'production' && (level === logLevels.WARN || level === logLevels.ERROR)) ||
      runtimeConfig.ENV !== 'production'
    ) {
      const metadata = {
        resource: { type: 'global' },
        severity: level.toUpperCase(),
      };
      const entry = glog.entry(metadata, logMessage.message);

      // Write the log entry asynchronously
      glog.write(entry).catch((err) => {
        console.error('Error writing to Google Cloud Logging:', err);
      });
    }
  } else {
    // Local or non-production environment logging
    if (runtimeConfig.ENV === 'local') {
      // Log to the console with color based on level
      switch (level) {
        case 'debug':
          console.log('\x1b[36m%s\x1b[0m', logMessage.message);
          break;
        case 'info':
          console.log('\x1b[90m%s\x1b[0m', logMessage.message);
          break;
        case 'warn':
          console.log('\x1b[33m%s\x1b[0m', logMessage.message);
          break;
        case 'error':
          console.log('\x1b[31m%s\x1b[0m', logMessage.message);
          break;
        default:
          console.log(logMessage.message);
      }
    }
  }
};

const debug = (...args) => log(logLevels.DEBUG, ...args);
const info = (...args) => log(logLevels.INFO, ...args);
const warn = (...args) => log(logLevels.WARN, ...args);
const error = (...args) => {
  const runtimeConfig = useRuntimeConfig();

  log(logLevels.ERROR, ...args);
  // Check if any of the arguments is an Error instance
  if (runtimeConfig.ENV_TYPE === 'production') {
    const errorArg = args.find((arg) => arg instanceof Error);
    // if (errorArg) {
    //   Sentry.captureException(errorArg);
    // } else {
    //   Sentry.captureMessage(formatMessage(args));
    // }
  }
};

export default {
  debug,
  info,
  warn,
  error,
  time,
  timeEnd,
};
